import axios from "axios";
import { createContext, useEffect, useState } from "react";
const apivalue = createContext();
function Data({ children }) {
  const [api, setApi] = useState([]);
  useEffect(() => {
    axios.get("/api.json").then((element) => {
      setApi(element.data.products);
    });
  }, []);
  return <apivalue.Provider value={api}>{children}</apivalue.Provider>;
}

export { Data, apivalue };
